export default __webpack_public_path__ + "static/media/homepage-logo.811f030a.png";